import { BASE_URL } from '@constants/api'
import {
	ListDashboardRequest,
	ListDashboardResponse,
	ListRecurrentQuestionsRequest,
	ListRecurrentQuestionsResponse,
} from '@models/dashboard.model'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setAuthorization } from '@utils/helpers'

export const dashboardApi = createApi({
	reducerPath: 'dashboard',
	tagTypes: ['Dashboard', 'RecurrentQuestions'],
	baseQuery: fetchBaseQuery({
		baseUrl: BASE_URL,
		prepareHeaders: setAuthorization,
	}),
	endpoints: (builder) => ({
		list: builder.query<ListDashboardResponse, ListDashboardRequest>({
			query: ({ month = '', year = 2023 }) => ({
				url: `/dashboard?month=${month}&year=${year}`,
				method: 'GET',
			}),
			providesTags: ['Dashboard'],
		}),

		getRecurrentQuestions: builder.query<
			ListRecurrentQuestionsResponse,
			ListRecurrentQuestionsRequest
		>({
			query: ({ disciplineId, yearId, juryId }) => ({
				url: '/recurrent-question',
				method: 'GET',

				params: {
					disciplineId,
					yearId,
					juryId,
				},
			}),
			providesTags: ['RecurrentQuestions'],
		}),
	}),
})

export const { useListQuery, useGetRecurrentQuestionsQuery } = dashboardApi
